import React from 'react'
import EmailChangeConfirmationCard from '@/components/EmailChangeConfirmationCard/EmailChangeConfirmationCard';

const EmailChangeConfirmation: React.FC = () => {

    React.useEffect(() => {
        window.scroll({ top: 0, left: 0, behavior: 'auto' })
    }, []);

    return (
        <EmailChangeConfirmationCard />
    )
}

export default EmailChangeConfirmation
